import React from 'react'
import css from './style.css'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { toggleDisplayCart } from '../../actions/settings'
import { cartFieldChanged } from '../../actions/cart'
import { clearCustomDeposit } from '../../actions/summary'
import Spacer from '../../components/spacer'
import Button from '../../components/button'
import { OrderLineInput } from '../../components/order-line'
import SelectItem from '../../components/select-item'
import { InputFieldTypes } from '../../utils/input-field-types'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.cart,
    cartVisible: state.settings.cartVisible
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    hideCart: () => {
      dispatch(toggleDisplayCart())
    },
    cartFieldChanged: (fieldType, field, value) => {
      let fieldVal
      if (fieldType === InputFieldTypes.NUMERIC) {
        fieldVal = parseFloat(value.target.value) || 0
      } else if (fieldType === InputFieldTypes.TEXT) {
        fieldVal = value.target.value
      } else {
        fieldVal = value
      }
      dispatch(cartFieldChanged(field, fieldVal))
    },
    clearCustomDeposit: () => {
      dispatch(clearCustomDeposit())
    }
  }
}

export const CartSummary = (props) => {
  return (
    <div className={props.cartVisible ? css.summary : css.summaryHide}>
      <Spacer xxs />
      <OrderLineInput
        name='Client Budget'
        value={props.clientBudget}
        prefix='$'
        min={0}
        onChange={props.cartFieldChanged.bind(this, InputFieldTypes.NUMERIC, 'clientBudget')} />
      <Spacer xxs />
      <SelectItem
        sm
        id='client_budget_tax_options'
        options={[
          {value: false, label: 'Pre-Tax'},
          {value: true, label: 'Post-Tax'}
        ]}
        value={props.clientBudgetIsAfterTax}
        onChange={props.cartFieldChanged.bind(this, InputFieldTypes.BOOLEAN, 'clientBudgetIsAfterTax')}
        initVal={false}
      />
      <Spacer xxs />
      {props.clientBudgetIsAfterTax &&
        <OrderLineInput
          name='Tax Rate'
          value={props.taxPercent}
          suffix='%'
          min={0}
          step={0.01}
          onChange={props.cartFieldChanged.bind(this, InputFieldTypes.NUMERIC, 'taxPercent')} />}
      <Spacer xxs />
      <Button center onClick={() => {
        props.clearCustomDeposit()
        props.router.push('/summary')
        props.hideCart()
      }}>View Summary</Button>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CartSummary))



// WEBPACK FOOTER //
// ./src/containers/cart/cart-summary.js